import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';

import Copyright from 'components/Copyright';
import fetchHelper, { isOkHttpResponse } from 'services/apiService';
import logo from 'assets/Logo_MigrationWiz Horizontal on Light.svg';
import type {
  LogoutRequestBody,
  LogoutResponseBody,
} from 'state/shared/apiTypes';
import { sendErrorNotification } from 'state/shared/sendNotifications';
import { buildApiUrl } from 'environment';

import useStyles from './SignOut.style';

const useQuery = () => new URLSearchParams(useLocation().search);

const SignOut: React.FC = () => {
  const classes = useStyles();
  const queryParams = useQuery();
  const [errorCount, setErrorCount] = useState(1);

  const logout = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    const logoutId = queryParams.get('logoutId');
    const response = await fetchHelper
      .post<LogoutRequestBody, LogoutResponseBody>(buildApiUrl('signOut'), {
        logoutId,
      })
      .catch((err: string) => {
        // network error
        sendErrorNotification(
          'signOutError',
          `Request failed ☠️ - ${err}`,
          errorCount,
          () => setErrorCount(errorCount + 1)
        );
        return null;
      });
    if (
      response &&
      isOkHttpResponse<typeof response, LogoutResponseBody>(
        response,
        response.parsedBody
      )
    ) {
      const postLogoutRedirectUrl =
        response.parsedBody.postLogoutRedirectUri || 'https://bittitan.com';
      window.location.assign(postLogoutRedirectUrl);
    } else if (response) {
      // backend error
      sendErrorNotification(
        'signOutError',
        `Error ${response.status} - 🤮 OHNOES!`,
        errorCount,
        () => setErrorCount(errorCount + 1)
      );
    }
  };

  return (
    <Container component="main" maxWidth="xs" className={classes.container}>
      <div className={classes.paper}>
        <img className={classes.logo} src={logo} alt="Logo" />
        <form className={classes.form} noValidate onSubmit={logout}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign out
          </Button>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default SignOut;
